import { FREIGHT_LANE_DATE_TYPES } from 'utils/constants'
import { dateFormatter } from 'utils/data-manipulation/valueFormatter'

export const formatPriceDate = (date, type = FREIGHT_LANE_DATE_TYPES.EFFECTIVE) => {
  if (!date || Number.isNaN(new Date(date).getTime())) return null

  const cleanedDate = dateFormatter(date)
  const timeAppend = type === FREIGHT_LANE_DATE_TYPES.EFFECTIVE ? '00:00:00' : '23:59:59'
  return new Date(`${cleanedDate} ${timeAppend}`).toISOString()
}
